<template>
  <div class="conflicts">
    <div class="error">
      <span><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>
      {{ _.overlapping_participations_detected }}
    </div>
    <div v-for="(pval, pkey) in persons" :key="'person-' + pkey">
      <div class="item" v-html="getPerson(pval)"></div>
      <table>
        <tbody v-for="(sval, skey) in pval" :key="'session' + skey">
          <tr>
            <td></td>
            <td style="padding-top: 6px" :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }">
              {{ formatDate(sval.day) }}, {{ sval.start_time }} - {{ sval.end_time }}
            </td>
            <td style="padding-top: 6px" :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4', 'text-align': 'right' }">
              {{ sval.room['name_' + language] }}
            </td>
          </tr>
          <tr v-if="sval.session_type">
            <td></td>
            <td :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }" colspan="2">
              {{ _[sval.session_type.name] }}
            </td>
          </tr>
          <tr class="title session">
            <td></td>
            <td :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }" colspan="2">
              <router-link :to="'/session/' + sval.id + '/persons'">
                <b>{{ sval.code }} {{ sval.title }}</b>
              </router-link>
            </td>
          </tr>

          <!-- Session Person Conflict -->

          <tr v-if="sval.persons.length > 0" class="person">
            <td style="padding-bottom: 6px">
              <div class="time" :class="{ clarified: getSessionPersonConflictStatus(sval.id, sval.persons[0].person_id) }">{{ sval.start_time }} &ndash; {{ sval.end_time }}</div>
            </td>
            <td style="padding-bottom: 6px" :style="{ color: (sval.session_type) ? sval.session_type.value.color : '#000000', background: (sval.session_type) ? sval.session_type.value.background : '#e4e4e4' }" colspan="2">
              <div class="person"  :class="{ clarified: getSessionPersonConflictStatus(sval.id, sval.persons[0].person_id) }">
                <span v-html="formatPerson(sval.persons[0])"></span>
                <label style="margin-left: 12px;">
                  <input
                    style="vertical-align: middle; margin-top: -1px;"
                    type="checkbox"
                    :checked="getSessionPersonConflictStatus(sval.id, sval.persons[0].person_id)"
                    @click="toggleStatus(sval.id, null, sval.persons[0].person_id, getSessionPersonConflictStatus(sval.id, sval.persons[0].person_id))" />
                  {{ _.cleared }}
                </label>
              </div>
            </td>
          </tr>

          <template v-for="(cval, ckey) in sval.presentations">

            <tr class="title presentation" :key="'time-' + ckey">
              <td></td>
              <td colspan="2" :style="[ ckey == 0 ? {'padding-top': '6px'} : {'padding-top': '0px'} ]">
                <span v-if="cval.start_time && cval.end_time">{{ cval.start_time }} &ndash; {{ cval.end_time }}</span>
                <span v-else>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
              </td>
            </tr>
            <tr class="title presentation" :key="'title-' + ckey">
              <td></td>
              <td colspan="2">
                <router-link :to="'/presentation/' + cval.presentation.id + '/persons'">
                  <b>{{ cval.presentation.title }}</b>
                </router-link>
              </td>
            </tr>

            <!-- Presentation Person Conflict -->

            <tr :key="'person' + ckey">
              <td style="padding-top: 4px; padding-bottom: 6px">
                <div class="time" :class="{ clarified: getPresentationPersonConflictStatus(sval.id, cval.presentation_id, cval.presentation.persons[0].person_id) }" v-if="settings.app.participation_overlapping_presentation_times === 'presentation'">
                  <span v-if="cval.start_time && cval.end_time">{{ cval.start_time }} &ndash; {{ cval.end_time }}</span>
                  <span v-else>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
                </div>
                <div class="time" :class="{ clarified: getPresentationPersonConflictStatus(sval.id, cval.presentation_id, cval.presentation.persons[0].person_id) }" v-if="settings.app.participation_overlapping_presentation_times === 'session'">
                  {{ sval.start_time }} &ndash; {{ sval.end_time }}
                </div>
              </td>
              <td colspan="2" style="padding-top: 4px; padding-bottom: 6px">
                <div class="person" :class="{ clarified: getPresentationPersonConflictStatus(sval.id, cval.presentation_id, cval.presentation.persons[0].person_id) }">
                  <span v-html="formatPerson(cval.presentation.persons[0])"></span>
                  <label style="margin-left: 12px;">
                    <input style="vertical-align: middle; margin-top: -1px;"
                      type="checkbox"
                      :checked="getPresentationPersonConflictStatus(sval.id, cval.presentation_id, cval.presentation.persons[0].person_id)"
                      @click="toggleStatus(sval.id, cval.presentation_id, cval.presentation.persons[0].person_id, getPresentationPersonConflictStatus(sval.id, cval.presentation_id, cval.presentation.persons[0].person_id))" />
                    {{ _.cleared }}
                  </label>
                </div>
              </td>
            </tr>

          </template>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
export default {
  props: ['id'],
  data() {
    return {
      overlappings: [],
      persons: [],
    }
  },
  methods: {
    getPerson(sessions) {
      let person = {};
      if (sessions[0].persons.length > 0) person = sessions[0].persons[0].person;
      else if (sessions[0].presentations.length > 0) person = sessions[0].presentations[0].presentation.persons[0].person;
      let name = person.first_name + ' ' + person.last_name;
      let affiliation = [];
      if (person.city) affiliation.push(person.city);
      if (person.country) affiliation.push(person.country.value.kfz);
      affiliation = (affiliation.length > 0) ? '(' + affiliation.join(', ') + ')' : '';
      return '<b>' + name + '</b> ' + affiliation;
    },
    formatPerson(person) {
      let role = person.role.name;
      let name = person.person.first_name + ' ' + person.person.last_name;
      let affiliation = [];
      if (person.person.city) affiliation.push(person.person.city);
      if (person.person.country && person.person.country.value.display) affiliation.push(person.person.country.value.kfz);
      affiliation = (affiliation.length > 0) ? '(' + affiliation.join(', ') + ')' : '';
      return role + ': <b>' + name + '</b> ' + affiliation;
    },
    getSessionPersonConflictStatus(session_id, person_id) {
      return this.overlappings.some(overlapping => overlapping.session_id === session_id && overlapping.person_id === person_id && overlapping.clarified === true);
    },
    getPresentationPersonConflictStatus(session_id, presentationId, person_id) {
      return this.overlappings.some(overlapping => overlapping.session_id === session_id && overlapping.presentation_id === presentationId && overlapping.person_id === person_id && overlapping.clarified === true);
    },
    async toggleStatus(session_id, presentation_id, person_id, clarified) {
      await this.axios.post(API_URL + '/participationoverlappings', { session_id: session_id, presentation_id: presentation_id, person_id: person_id, clarified: !clarified });
      this.getConflicts();
    },
    async getConflicts() {
      const conflicts = await this.axios.get(API_URL + '/sessions/' + this.id + '/overlappingpersons');
      this.overlappings = conflicts.data.overlappings;
      this.persons = conflicts.data.persons;
      this.setProgress(false);
    },
  },
  async created() {
    this.getConflicts();
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/conflicts';
</style>